<template>
  <form v-if="entity" class="region-form view row" @submit="onSave({close: false})">
    <div class="col-12">

      <form-model-controls :docs="actionDocs" v-model="entity"/>

      <!-- CATEGORIES SECTION -->
      <collapse>
        <template v-slot:header="{active}">
          <hr>
          <h3 class="d-flex justify-content-between pr-2">
            {{ $t('Categories') }}
            <i :class="{active}" class="fas fa-chevron-down"></i>
          </h3>
          <hr>
        </template>
        <template v-slot:content>
          <div class="row align-items-end mb-4">
            <div class="col-10">
              <form-input
                  :label="$t('new top level category')"
                  class="mb-0"
                  v-model="topLevelCategory"
              />
            </div>
            <div class="col">
              <button type="button"
                      class="btn btn-primary btn-lg btn-block"
                      @click="tryAddCategory({name: topLevelCategory, regionId})"
              >{{ $t('add') }}
              </button>
            </div>
          </div>
          <category-tree class="border p-1 mb-3"
                         :categories="categories"
                         @delete="tryDeleteCategory"
                         @add="tryAddCategory"
                         @modify="tryModifyCategory"
          />
        </template>
      </collapse>

      <!--      TargetGroup-->


    </div>
    <div class="col-12 ">
      <!-- eLEARNING -->
      <collapse>
        <template v-slot:header="{active}">
          <hr>
          <h3 class="d-flex justify-content-between pr-2">
            {{ $t('eLEARNING') }}
            <i :class="{active}" class="fas fa-chevron-down"></i>
          </h3>
          <hr>
        </template>
        <template v-slot:content>
          <form-switch :label="$t('Campus Module eLEARNING')"
                       v-model="entity.public_config.elearning.enabled"
          />
          <transition name="fade">
            <div class="mb-6 mt-3" v-if="entity.public_config.elearning.enabled">
              <div class="d-flex justify-content-between align-items-center">
                <h2>{{ $t('Modules') }}</h2>
                <router-link class="btn btn-primary btn-sm"
                             :to="['/regions', regionId, 'modules', 'new'].join('/')"
                >
                  <i class="fas fa-plus"></i> <i class="fas fa-tv"></i>
                </router-link>
              </div>
              <sortable-list :items="filterForRegion(modules)" :loading="modulesLoading" default-sort-key="name">
                <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                  <div class="row">
                    <sortable-list-column-header
                        class="col-4"
                        sort-key="name"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="company"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('company name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="title"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('title') }}
                    </sortable-list-column-header>
                  </div>
                </template>
                <template v-slot:itemTemplate="{item}">
                  <div class="row align-items-center">
                    <div class="col-4">
                      {{ item.name }}
                    </div>
                    <div class="col-3">
                      {{ item.company }}
                    </div>
                    <div class="col-3">
                      {{ item.title }}
                    </div>
                    <div class="col-2 pr-2">
                      <router-link class="btn btn-primary btn-block"
                                   :to="['/regions', regionId, 'modules','edit', item.id].join('/')"
                      >
                        {{ $t('edit') }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-slot:emptyList>
                  <empty-list-note :body-text="$t('Es gibt noch keine Referenten in dieser Region')"></empty-list-note>
                </template>
              </sortable-list>
              <div class="d-flex justify-content-between align-items-center">
                <h2>{{ $t('Products') }}</h2>
                <router-link class="btn btn-primary btn-sm"
                             :to="['/regions', regionId, 'products', 'new'].join('/')"
                >
                  <i class="fas fa-plus"></i> <i class="fas fa-shopping-cart"></i>
                </router-link>
              </div>
              <sortable-list :items="filterForRegion(products)" :loading="productsLoading" default-sort-key="name">
                <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                  <div class="row">
                    <sortable-list-column-header
                        class="col-4"
                        sort-key="name"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('Product name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="sku"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('SKU') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="value"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('value') }}
                    </sortable-list-column-header>
                  </div>
                </template>
                <template v-slot:itemTemplate="{item}">
                  <div class="row align-items-center">
                    <div class="col-4">
                      {{ item.name }}
                    </div>
                    <div class="col-3">
                      {{ item.sku }}
                    </div>
                    <div class="col-3">
                      {{ item.value }}
                    </div>
                    <div class="col-2 pr-2">
                      <router-link class="btn btn-primary btn-block"
                                   :to="['/regions', regionId, 'products','edit', item.id].join('/')"
                      >
                        {{ $t('edit') }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-slot:emptyList>
                  <empty-list-note :body-text="$t('Es gibt noch keine Prämien in dieser Region')"></empty-list-note>
                </template>
              </sortable-list>

              <h2>{{ $t('Orders') }}</h2>
              <sortable-list :items="filterForRegion(orders)" :loading="ordersLoading" default-sort-key="name">
                <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                  <div class="row">
                    <sortable-list-column-header
                        class="col-4"
                        sort-key="name"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="company"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('company name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="title"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('title') }}
                    </sortable-list-column-header>
                  </div>
                </template>
                <template v-slot:itemTemplate="{item}">
                  <div class="row align-items-center">
                    <div class="col-4">
                      {{ item.name }}
                    </div>
                    <div class="col-3">
                      {{ item.company }}
                    </div>
                    <div class="col-3">
                      {{ item.title }}
                    </div>
                    <div class="col-2 pr-2">
                      <router-link class="btn btn-primary btn-block"
                                   :to="['/regions', regionId, 'modules','edit', item.id].join('/')"
                      >
                        {{ $t('edit') }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-slot:emptyList>
                  <empty-list-note :body-text="$t('Es gibt noch keine Prämien in dieser Region')"></empty-list-note>
                </template>
              </sortable-list>

              <h2>{{ $t('Users') }}</h2>
              <sortable-list :items="filterForRegion(users)" :loading="usersLoading" default-sort-key="name">
                <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                  <div class="row">
                    <sortable-list-column-header
                        class="col-4"
                        sort-key="email"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('email') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="institution"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('company name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="first_name"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('name') }}
                    </sortable-list-column-header>
                  </div>
                </template>
                <template v-slot:itemTemplate="{item}">
                  <div class="row align-items-center">
                    <div class="col-4">
                      {{ item.email }}
                    </div>
                    <div class="col-3">
                      {{ item.institution }}
                    </div>
                    <div class="col-3">
                      {{ [item.first_name, item.last_name].join(' ') }}
                    </div>
                    <div class="col-2 pr-2">
                      <router-link class="btn btn-primary btn-block"
                                   :to="['/regions', regionId, 'users','edit', item.id].join('/')"
                      >
                        {{ $t('edit') }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-slot:emptyList>
                  <empty-list-note :body-text="$t('Es gibt noch keine Prämien in dieser Region')"></empty-list-note>
                </template>
              </sortable-list>


              <div class="d-flex justify-content-between align-items-center">
                <h2>{{ $t('UserGroup') }}</h2>
                <router-link class="btn btn-primary btn-sm"
                             :to="['/regions', regionId, 'groups', 'new'].join('/')"
                >
                  <i class="fas fa-plus"></i> <i class="fas fa-tv"></i>
                </router-link>
              </div>

              <sortable-list :items="filterForRegion(userGroups)"
                             :loading="userGroupsLoading"
                             default-sort-key="name">
                <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                  <div class="row">
                    <sortable-list-column-header
                        class="col-4"
                        sort-key="name"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="company"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('company name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="title"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('title') }}
                    </sortable-list-column-header>
                  </div>
                </template>
                <template v-slot:itemTemplate="{item}">
                  <div class="row align-items-center">
                    <div class="col-4">
                      {{ item.name }}
                    </div>
                    <div class="col-3">
                      {{ item.company }}
                    </div>
                    <div class="col-3">
                      {{ item.title }}
                    </div>
                    <div class="col-2 pr-2">
                      <router-link class="btn btn-primary btn-block"
                                   :to="['/regions', regionId, 'groups','edit', item.id].join('/')"
                      >
                        {{ $t('edit') }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-slot:emptyList>
                  <empty-list-note :body-text="$t('Es gibt noch keine Prämien in dieser Region')"></empty-list-note>
                </template>
              </sortable-list>
            </div>
          </transition>
          <hr>
        </template>
      </collapse>


    </div>
    <div class="col-12">
      <!-- (WEB-)SEMINARE -->
      <collapse>
        <template v-slot:header="{active}">
          <hr>
          <h3 class="d-flex justify-content-between pr-2">
            {{ $t('Seminare / Web-Seminare') }}
            <i :class="{active}" class="fas fa-chevron-down"></i>
          </h3>
          <hr>
        </template>
        <template v-slot:content>
          <div class="row">
            <div class="col">
              <form-switch :label="$t('Campus Module Seminare')"
                           v-model="entity.public_config.seminars.enabled"
              />
            </div>
            <div class="col">
              <form-switch :label="$t('Campus Module Web-Seminare')"
                           v-model="entity.public_config.webinars.enabled"
              />
            </div>

          </div>
          <transition name="fade">
            <div class="mb-6" v-if="entity.public_config.seminars.enabled || entity.public_config.webinars.enabled">
              <hr>
              <div class="d-flex justify-content-between align-items-center">
                <h2>{{ $t('speakers') }}</h2>
                <router-link class="btn btn-primary btn-sm"
                             :to="['/regions', regionId, 'speakers', 'new'].join('/')">
                  <i class="fas fa-plus"></i> <i class="fas fa-user"></i>
                </router-link>
              </div>
              <sortable-list :items="filterForRegion(speakers)" :loading="speakersLoading" default-sort-key="name">
                <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                  <div class="row">
                    <sortable-list-column-header
                        class="col-4"
                        sort-key="name"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="company"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('company name') }}
                    </sortable-list-column-header>
                    <sortable-list-column-header
                        class="col-3"
                        sort-key="title"
                        :sort-a-s-c="sortDirection"
                        :sort-by="sortKey"
                        :set-sort-key="setSortKey"
                        :toggle-direction="toggleDirection"
                    >
                      {{ $t('title') }}
                    </sortable-list-column-header>
                  </div>
                </template>
                <template v-slot:itemTemplate="{item}">
                  <div class="row align-items-center">
                    <div class="col-4">
                      {{ item.name }}
                    </div>
                    <div class="col-3">
                      {{ item.company }}
                    </div>
                    <div class="col-3">
                      {{ item.title }}
                    </div>
                    <div class="col-2 pr-2">
                      <router-link class="btn btn-primary btn-block"
                                   :to="['/regions', regionId, 'speakers','edit', item.id].join('/')"
                      >
                        {{ $t('edit') }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-slot:emptyList>
                  <empty-list-note :body-text="$t('Es gibt noch keine Referenten in dieser Region')"></empty-list-note>
                </template>
              </sortable-list>

              <template v-if="entity.public_config.seminars.enabled">
                <div class="d-flex justify-content-between align-items-center">
                  <h2>{{ $t('Seminare') }}</h2>
                  <router-link class="btn btn-primary btn-sm"
                               :to="['/regions', regionId, 'trainings', 'new','seminar'].join('/')"
                  >
                    <i class="fas fa-plus"></i> <i class="fas fa-chalkboard-teacher"></i>
                  </router-link>
                </div>
                <sortable-list :items="filterForRegion(seminars)" :loading="trainingsLoading" default-sort-key="code">
                  <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                    <div class="row">
                      <sortable-list-column-header
                          class="col-2"
                          sort-key="code"
                          :sort-a-s-c="sortDirection"
                          :sort-by="sortKey"
                          :set-sort-key="setSortKey"
                          :toggle-direction="toggleDirection"
                      >
                        {{ $t('training_code') }}
                      </sortable-list-column-header>
                      <sortable-list-column-header
                          class="col"
                          sort-key="name"
                          :sort-a-s-c="sortDirection"
                          :sort-by="sortKey"
                          :set-sort-key="setSortKey"
                          :toggle-direction="toggleDirection"
                      >
                        {{ $t('training_name') }}
                      </sortable-list-column-header>
                    </div>
                  </template>
                  <template v-slot:itemTemplate="{item}">
                    <div class="row">
                      <div class="col-2">
                        {{ item.code }}
                      </div>
                      <div class="col">
                        {{ item.name }}
                      </div>
                      <div class="col-2 pr-2">
                        <router-link class="btn btn-primary btn-block"
                                     :to="['/regions', regionId, 'trainings','edit', item.id].join('/')"
                        >
                          {{ $t('edit') }}
                        </router-link>
                      </div>
                    </div>
                  </template>
                  <template v-slot:emptyList>
                    <empty-list-note :body-text="$t('Es gibt noch keine Seminare in dieser Region')"></empty-list-note>
                  </template>
                </sortable-list>
              </template>

              <template v-if="entity.public_config.webinars.enabled">

                <div class="d-flex justify-content-between align-items-center">
                  <h2>{{ $t('Web-Seminare') }}</h2>
                  <router-link class="btn btn-primary btn-sm"
                               :to="['/regions', regionId, 'trainings', 'new','webinar'].join('/')"
                  >
                    <i class="fas fa-plus"></i> <i class="fas fa-laptop"></i>
                  </router-link>
                </div>
                <sortable-list :items="filterForRegion(webSeminars)"
                               :loading="trainingsLoading"
                               default-sort-key="code">
                  <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
                    <div class="row">
                      <sortable-list-column-header
                          class="col-2"
                          sort-key="code"
                          :sort-a-s-c="sortDirection"
                          :sort-by="sortKey"
                          :set-sort-key="setSortKey"
                          :toggle-direction="toggleDirection"
                      >
                        {{ $t('training_code') }}
                      </sortable-list-column-header>
                      <sortable-list-column-header
                          class="col"
                          sort-key="name"
                          :sort-a-s-c="sortDirection"
                          :sort-by="sortKey"
                          :set-sort-key="setSortKey"
                          :toggle-direction="toggleDirection"
                      >
                        {{ $t('training_name') }}
                      </sortable-list-column-header>
                    </div>
                  </template>
                  <template v-slot:itemTemplate="{item}">
                    <div class="row">
                      <div class="col-2">
                        {{ item.code }}
                      </div>
                      <div class="col">
                        {{ item.name }}
                      </div>
                      <div class="col-2 pr-0">
                        <router-link class="btn btn-primary btn-block"
                                     :to="['/regions', regionId, 'trainings','edit', item.id].join('/')"
                        >
                          {{ $t('edit') }}
                        </router-link>
                      </div>
                    </div>
                  </template>
                  <template v-slot:emptyList>
                    <empty-list-note :body-text="$t('Es gibt noch keine Web-Seminare in dieser Region')"></empty-list-note>
                  </template>
                </sortable-list>
              </template>
            </div>
          </transition>
        </template>
      </collapse>

    </div>

    <div class="col-12 py-5">

      <bottom-tool-bar :can-delete="!!regionId" @save="onSave" @delete="onDelete"/>
    </div>
    <confirmation-modal v-if="showDirtyModal"
                        :title="$t('Achtung')"
                        @close="cancelNavigation">
      <template v-slot:default>
        {{ $t('Sie haben ungespeicherte Änderungen. Wie wollen Sie fortfahren?') }}
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-danger" @click="dontSave">
          {{ $t('Nicht speichern') }}
        </button>
        <button type="button" class="btn btn-primary" @click="onSave({close: true})">
          {{ $t('Speichern') }}
        </button>
      </template>
    </confirmation-modal>
  </form>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
// Mixins
import ViewDirtyMixin from '@/mixins/view-dirty'
// Components
import FormInput from "@/components/Form/FormInput";
import FormSwitch from "@/components/Form/FormSwitch";
import SortableList from "@/components/SortableList";
import EmptyListNote from "@/components/EmptyListNote";
import SortableListColumnHeader from "@/components/SortableListColumnHeader";
import ConfirmationModal from "@/components/ConfirmationModal";
import CategoryTree from "@/components/CategoryTree";
// import RichTextEditor from "@/components/RichTextEditor";
import Collapse from "@/components/PsCollapse";
import FormModelControls from "@/components/Form/FormModelControls";
import BottomToolBar from "@/components/BottomToolBar";

export default {
  name: "RegionForm",
  mixins: [ViewDirtyMixin],
  components: {
    BottomToolBar,
    FormModelControls,
    Collapse,
    // RichTextEditor,
    CategoryTree,
    ConfirmationModal, SortableListColumnHeader, EmptyListNote, SortableList, FormSwitch, FormInput
  },
  props: {
    regionId: {type: String, default: null}
  },
  data() {
    return {
      entity: {
        name: '',
        public_config: {
          intro: '',
          seminarImageUrl: '',
          seminarIntro: '',
          webinarImageUrl: '',
          webinarIntro: '',
          eLearningImageUrl: '',
          eLearningIntro: '',
        },
        private_config: {},
      },
      topLevelCategory: '',
      categoriesLoading: false,
      speakersLoading: false,
      trainingsLoading: false,
      modulesLoading: false,
      productsLoading: false,
      ordersLoading: false,
      usersLoading: false,
      userGroupsLoading: false,
      showExpertSettings: false,
    }
  },
  watch: {
    regionId(nv, ov) {
      if (nv && nv !== ov) {
        this.fetchRegion()
      }
    }
  },
  computed: {
    ...mapState({
      storedRegion: state => state.Api.Regions.current,
      modules: state => state.Api.Modules.all,
      products: state => state.Api.Products.all,
      orders: state => state.Api.Orders.all,
      users: state => state.Api.Users.all,
      userGroups: state => state.Api.Groups.all,
      speakers: state => state.Api.Speakers.all,
      trainings: state => state.Api.Trainings.all,
      categories: state => state.Api.Categories.all,
    }),
    seminars() {
      return this.trainings.filter(el => el.type === 'seminar')
    },
    webSeminars() {
      return this.trainings.filter(el => el.type === 'webinar')
    },
    actionDocs() {
      if (this.regionId) {
        return this.$apiData.Regions.find(action => action.name === 'modify')
      }

      return this.$apiData.Regions.find(action => action.name === 'add')
    }
  },
  mounted() {
    this.fetchRegion();

    this.categoriesLoading = true;
    this.getCategories({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.categoriesLoading = false);

    this.speakersLoading = true;
    this.getSpeakers({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.speakersLoading = false);

    this.trainingsLoading = true;
    this.getTrainings({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.trainingsLoading = false);

    this.modulesLoading = true;
    this.getModules({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.modulesLoading = false);

    this.productsLoading = true;
    this.getProducts({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.productsLoading = false);

    this.ordersLoading = true;
    this.getOrders({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.ordersLoading = false);

    this.usersLoading = true;
    this.getUsers({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.usersLoading = false);

    this.userGroupsLoading = true;
    this.getGroups({region_id: this.regionId, limit: Number.MAX_SAFE_INTEGER})
        .catch(this.apiErrorHandler)
        .finally(() => this.userGroupsLoading = false);

  },
  methods: {
    ...mapMutations({
      setCurrentRegion: "Api/Regions/setCurrent",
      clearCategories: "Api/Categories/reset"
    }),
    ...mapActions({
      getRegion: "Api/Regions/get",
      getCategories: "Api/Categories/all",
      getModules: "Api/Modules/all",
      getProducts: "Api/Products/all",
      getOrders: "Api/Orders/all",
      getUsers: "Api/Users/all",
      getGroups: "Api/Groups/all",
      getSpeakers: "Api/Speakers/all",
      getTrainings: "Api/Trainings/all",
      modifyRegion: "Api/Regions/modify",
      deleteRegion: "Api/Regions/delete",
      addCategory: "Api/Categories/add",
      modifyCategory: "Api/Categories/modify",
      deleteCategory: "Api/Categories/delete",
    }),
    filterForRegion(list) {
      return list.filter(el => el.region_id === this.regionId)
    },
    tryDeleteCategory(catId) {
      this.deleteCategory({id: catId})
          .then(() => {
            this.clearCategories();

            this.getCategories({
              region_id: this.regionId,
              limit: Number.MAX_SAFE_INTEGER
            })
          })
          .catch(this.apiErrorHandler)
    },
    tryAddCategory(cat) {
      this.addCategory({...cat, region_id: this.regionId})
          .then(() => {
            this.clearCategories();
            this.getCategories({
              region_id: this.regionId,
              limit: Number.MAX_SAFE_INTEGER
            })
          })
          .catch(this.apiErrorHandler)
    },
    tryModifyCategory(cat) {
      this.modifyCategory({...cat, region_id: this.regionId})
          .then(() => {
            this.clearCategories();
            this.getCategories({
              region_id: this.regionId,
              limit: Number.MAX_SAFE_INTEGER
            })
          })
          .catch(this.apiErrorHandler)
    },
    fetchRegion() {
      if (this.entity && this.entity.id !== this.regionId) {
        this.entity = null
        this.setCurrentRegion({item: null});
      }
      this.getRegion({id: this.regionId})
          .then(region => this.entity = region)
          .catch(this.apiErrorHandler)
    },
    onSave({close}) {
      this.modifyRegion(this.entity)
          .then(close ? this.saveComplete : this.saveCompleteToast)
          .catch(this.apiErrorHandler)
    },
    onDelete() {
      this.deleteRegion({id: this.regionId})
          .then(this.saveComplete)
          .catch(this.apiErrorHandler);
    },
  }
}
</script>
